
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-co/ia/seguimiento-carga",
      function () {
        return require("private-next-pages/es-co/ia/seguimiento-carga/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-co/ia/seguimiento-carga"])
      });
    }
  